
  
const initState = {
    repContactAccount: [],
    page: 1,
    limit: 10,
    count: 0
  };
  
  const RepContactAccountReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_REP_CONTACT_ACCOUNT':
        return {
          ...state,
          repContactAccount: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_REP_CONTACT_ACCOUNT_STATE':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default RepContactAccountReducer;
  